<template>
  <div
    class="collection-info-section"
    :class="{'--open': isOpen}"
  >
    <div
      class="collection-info-section__head"
      @click="changeOpen"
    >
      <span class="h5 semibold">Характеристики</span>
      <img src="~/assets/img/svg/common/arrow-down.svg" alt="" />
    </div>
    <div class="collection-info-section__body">
      <div class="product-characteristics">
        <CharacteristicsRow
          v-for="(characteristic) in characteristics"
          :key="`characteristic-${characteristic.id}`"
          :label="characteristic.nameCustom"
          :value="characteristic.valueMessage"
          :label-button-more="characteristic.labelButtonOpen"
          :is-char-from-redactor="getCharFromRedactor(characteristic)"
          :is-values-gap="Boolean(characteristic.isValuesGap)"
          :is-full-width="Boolean(characteristic.isFullWidth)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type { ProductCharacteristic } from '#sitis/internal/controllers/products/models/Product';
import getCharFromRedactor from '~/utils/getCharFromRedactor'
import CharacteristicsRow from "./_CharacteristicsRow.vue";

const props = defineProps({
  product: {
    type: Object as any,
    default: () => {}
  }
});
const {
  $caseWords
} = useNuxtApp();

const characteristics: any = computed(() => {
  const hiddenSlugs = ['kommentarij-sluzhebnyj', 'discount-label-date', 'popular_categories'];

  let _characteristics: ProductCharacteristic[] = [];
  (props?.product?.characteristics || []).map((item: any) => {
    _characteristics.push(...(item?.characteristics || []));
  });
  _characteristics = _characteristics.filter((item: ProductCharacteristic) => {
    return Boolean(item.showInProduct && item.viewTemplate !== 'for_custom_sections' && !hiddenSlugs.includes(item.slug))
  });
  _characteristics = _characteristics.map((item: ProductCharacteristic) => {
    let valueMessage = (item?.values || []).map((t: any) => t.value).join(', ');
    let labelButtonOpen = '';
    if (item.viewTemplate === 'list_column') {
      valueMessage = (item?.values || []).map((t: any) => `<span class="--tag">${ t.value }</span>`).join('</br>');

      const hiddenCount = (item?.values || []).length - 2;
      if (hiddenCount > 0) {
        labelButtonOpen = `+${ hiddenCount } ${ $caseWords(hiddenCount, ['размер','размера','размеров']) }`
      }
    }

    return {
      ...item,
      nameCustom: String(item.nameForProduct || item.name || '').split(" ").map((t) => `<span>${t}</span>`).join(' '),
      isValuesGap: Boolean(item.viewTemplate === 'list_column'),
      isFullWidth: Boolean(item?.viewTemplate === 'full_width'),
      valueMessage: valueMessage,
      labelButtonOpen: labelButtonOpen
    };
  });

  return _characteristics;
});

const isOpen = ref(true);
const changeOpen = () => {
  isOpen.value = !isOpen.value;
};
</script>
